<template>
	<li :class="['store-selector-stock-row list-group-item', { selected }]">
		<div>
			<div class="store-name">
				<div>
					{{ this.store.name }}
				</div>
				<div class="sub-title">
					{{ this.store.city }}
				</div>
			</div>
			<span v-if="storeDistance" class="store-distance">{{ storeDistance }}</span>
		</div>
		<div class="store-stock">
			<span :class="['icon', stockClass]" /> {{ this.stockText }}
		</div>
	</li>
</template>

<script>

import { storeName, getStore } from 'datastore/i18n';
import { mapState } from 'vuex';
import stockUtils from 'utils/stock';

export default {
	props: {
		stock: {
			required: true
		},
		storeId: {
			required: true
		},
		cartRows: {
			required: true
		},
		selected: {
			required: true
		},
		storeDistance: {
			required: false,
			default: null
		},
	},
	data () {
		return {
			stockText: '',
			stockTextExtra: '',
			stockStatus: 1,
			stockClass: {
				'stock-icon-instock': true,
			},
		};
	},
	methods: {
		storeName,
		recalculateStock () {
			let release = null;
			for (const row of this.cartRows) {
				const r = row.product.release;
				if (! release || r.timestamp > release.timestamp) {
					release = r;
				}
			}
			const ret = stockUtils.calculateStockStatus(this.storeId, this.stock, this.userSettings, release, 'small');

			if (ret.stockClass.hasOwnProperty('stock-icon-instock')) {
				ret.stockText = 'Direkt';
			}

			this.stockText = ret.stockText;
			this.stockTextExtra = ret.stockTextExtra;
			this.stockStatus = ret.stockStatus;
			this.stockClass = ret.stockClass;
		},
	},
	mounted () {
		this.recalculateStock();
	},
	computed: {
		store () {
			return getStore(this.storeId);
		},
		...mapState({
			userSettings: state => state.userSettings,
		}),
	},
	watch: {
		stock (to) {
			this.recalculateStock();
		},
	},
};
</script>
